import cn from 'classnames'
import React, { useCallback } from 'react'

const AttributeSelectorMobile = ({ attributes, value, onChange, empty = 'Select...' }) => {
  const selectedAttribute = attributes.find((a) => a.id === value)

  const selectOption = useCallback(
    (attribute) => {
      const oldValue = value || []
      const newValue =
        oldValue.indexOf(attribute.id) >= 0 ? oldValue.filter((v) => v !== attribute.id) : [...oldValue, attribute.id]
      onChange(newValue)
    },
    [value]
  )

  return (
    <div className={cn('attribute-selector-mobile')}>
      <div className={cn('font-size-xs all-caps line-height-1', 'margin-right-l', 'no-margin-bottom')}>
        {selectedAttribute ? selectedAttribute.label : empty}
      </div>
      <div className={cn('attributes', 'flex flex-wrap gap-xxs')}>
        {attributes.map((attribute) => (
          <div
            key={attribute.id}
            className={cn(
              'attribute',
              (value || []).indexOf(attribute.id) >= 0 && 'selected',
              attribute.label.length > 20 && 'allow-wrap'
            )}
            onClick={() => selectOption(attribute)}>
            {attribute.label}
          </div>
        ))}
      </div>
    </div>
  )
}

export default AttributeSelectorMobile
